import React from "react";
import { Box, Typography, Alert } from "@mui/material";
import FileUploadZone from "./FileUploadZone";
import FilePreviewCard from "./FilePreviewCard";

export default function QuestionCard({
  question,
  uploadState,
  onFileSelect,
  onDelete,
  onView,
  onRetry,
  disabled,
}) {
  const { file, status, fileUrl, error } = uploadState ?? {};

  const isImageQuestion =
    typeof question.text === "string" &&
    (question.text.startsWith("data:image") ||
      question.text.startsWith("http") ||
      question.text.match(/\.(png|jpg|jpeg|gif|webp|svg)$/i));

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: "12px",
        border: "1px solid #e0e0e0",
        p: { xs: 2, sm: 2.5 },
        display: "flex",
        flexDirection: "column",
        mb: 2,
        boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "13px", sm: "14px" },
          fontWeight: "bold",
          mb: 0.5,
          color: "#1e1e1e",
        }}
      >
        Q.{question.questionNo}
      </Typography>

      {isImageQuestion ? (
        <Box
          component="img"
          src={question.text}
          alt={`Question ${question.questionNo}`}
          sx={{
            width: "100%",
            maxHeight: { xs: "320px", sm: "250px", md: "220px" },
            objectFit: "contain",
            objectPosition: "left center",
            mb: 1.5,
          }}
        />
      ) : (
        <Typography
          sx={{
            fontSize: { xs: "13px", sm: "14px" },
            color: "#1e1e1e",
            lineHeight: 1.6,
            mb: 1.5,
          }}
        >
          {question.text}
        </Typography>
      )}

      
      {error && !file && (
        <Alert severity="error" sx={{ mb: 1.5, py: 0.5, fontSize: "13px" }}>
          {error}
        </Alert>
      )}

      {!file ? (
        <FileUploadZone
          onFileSelect={(selectedFile, validationError) =>
            onFileSelect(question.id, selectedFile, validationError)
          }
          disabled={disabled}
        />
      ) : (
        <FilePreviewCard
          file={file}
          status={status}
          fileUrl={fileUrl}
          onDelete={() => onDelete(question.id)}
          onView={() => onView(fileUrl)}
          onRetry={() => onRetry(question.id)}
          disabled={disabled}
        />
      )}
    </Box>
  );
}
